import SVGridDetailStandaloneContainer from '@apps/www/src/www/containers/SVGridDetailStandaloneContainer';
import SVRedirect from '@apps/www/src/www/containers/SVRedirect';
import parseQueryParam from '@pkgs/shared/helpers/parseQueryParam';
import { useRouter } from 'next/router';

const SVGridDetailPage = () => {
	const router = useRouter();

	const itemShortID = parseQueryParam(router.query.itemShortID);

	if (!itemShortID) {
		return <SVRedirect to="/" />;
	}

	return <SVGridDetailStandaloneContainer itemShortID={itemShortID} />;
};

export default SVGridDetailPage;
